import React from 'react'
import Main from '../Main'
import loaderImg from 'assets/img/loaders/loader.svg'

const Loader = () => (
  <Main>
    <div className="text-center island"><img style={{width: '70px'}} src={loaderImg}alt="loading svg"/> Loading <img style={{width: '70px'}} src={loaderImg}alt="loading svg"/></div>
  </Main>
)

export default Loader
